import { useCallback } from 'react';
import { findSpectrumPickerScrollArea, usePopoverOnScrollRef } from '@deephaven/react-hooks';
/**
 * Handle scroll event registration and scrolling to initial scroll position
 * whenever a Picker popover is opened.
 * @param getInitialScrollPosition Function to get the initial scroll position.
 * @param onScroll Callback for scroll events.
 * @param onOpenChange Callback for open change events.
 * @return A ref to attach to the Picker and a callback to handle open change
 * events for the Picker.
 */
export function usePickerScrollOnOpen(_ref) {
  var getInitialScrollPosition = _ref.getInitialScrollPosition,
    onScroll = _ref.onScroll,
    onOpenChange = _ref.onOpenChange;
  var _usePopoverOnScrollRe = usePopoverOnScrollRef(findSpectrumPickerScrollArea, onScroll, getInitialScrollPosition),
    ref = _usePopoverOnScrollRe.ref,
    popoverOnOpenChange = _usePopoverOnScrollRe.onOpenChange;
  var onOpenChangeInternal = useCallback((isOpen, menuTrigger) => {
    // Attach scroll event handling
    popoverOnOpenChange(isOpen);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(isOpen, menuTrigger);
  }, [onOpenChange, popoverOnOpenChange]);
  return {
    ref,
    onOpenChange: onOpenChangeInternal
  };
}
export default usePickerScrollOnOpen;
//# sourceMappingURL=usePickerScrollOnOpen.js.map